import { render, staticRenderFns } from "./ClientSecton.vue?vue&type=template&id=b43cce00&"
import script from "./ClientSecton.vue?vue&type=script&lang=js&"
export * from "./ClientSecton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports